export const order_area_url: string = "order_area";